/* eslint-disable */

/**
 *
 * @param {string} method
 * @param {string} url
 * @param {mixed} data
 * @param {object} callback
 * @param {object} errorCallback
 */
var simpleXHR = function (method, url, data, successCallback, errorCallback) {
    var xhr = new (XMLHttpRequest || ActiveXObject)("MSXML2.XMLHTTP.3.0")
    xhr.open(method, url, true)
    xhr.setRequestHeader("Content-type", "application/json")
    xhr.setRequestHeader("Accept", "application/json")
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          successCallback(xhr.responseText)
        }
        else {
          errorCallback(xhr.responseText)
        }
      }
    }

    try {
      xhr.send(JSON.stringify(data))
    }
    catch (e) {
      reject(e.message)
    }
}

module.exports = simpleXHR
